import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FindControlIdService } from 'webcommon/legacy-common';
import { FindControlAdditionalSearchParametersDto, FindControlAdditionalSearchParametersType } from 'webcommon/shared';

export interface CheckboxData {
  checkboxText: string;
  formControl: FormControl<boolean | null>;
  formControlName: string;
  isFormControlDefaultValue: boolean;
  isCheckboxShouldBeChecked?: boolean;
  parameters?: FindControlAdditionalSearchParametersDto;
}

@Injectable({
  providedIn: 'root',
})

export class FcAdvancedConfig {
  readonly fcAdvancedConfig = new Map<string, CheckboxData[] | null>();
  readonly inactiveCheckbox = new FormControl(false);
  readonly defaultInactiveCheckbox: CheckboxData = {
    formControlName: 'inactiveCheckbox',
    isFormControlDefaultValue: false,
    checkboxText: 'Include Inactive Items',
    formControl: this.inactiveCheckbox
  };
  readonly defaultAdvancedConfig = [this.defaultInactiveCheckbox];
  readonly userDefineCheckbox = new FormControl(true);
  readonly includeExternalProviderCheckbox = new FormControl(false);
  readonly includeExternalSitesCheckbox = new FormControl(true);

  constructor(findControlIdService: FindControlIdService) {
    this.fcAdvancedConfig.set(findControlIdService.ListMisc, null); // then hide
    this.fcAdvancedConfig.set(FindControlIdService.ListZip, [
      this.defaultInactiveCheckbox,
      {
        formControlName: 'userDefineCheckbox',
        isFormControlDefaultValue: true,
        checkboxText: 'Include User Defined Items',
        formControl: this.userDefineCheckbox,
        isCheckboxShouldBeChecked: false,
        parameters: {
          Type: FindControlAdditionalSearchParametersType.Standard,
          AdditionalSearchParameters: [
            {
              ColumnName: 'UserDefined',
              Value: 'false',
            },
          ],
        },
      },
    ]);
    this.fcAdvancedConfig.set(FindControlIdService.ViewProvider, [
      this.defaultInactiveCheckbox,
      {
        checkboxText: 'Include External Providers',
        formControl: this.includeExternalProviderCheckbox,
        formControlName: 'includeExternalProviderCheckbox',
        isFormControlDefaultValue: false,
        isCheckboxShouldBeChecked: true,
        parameters: {
          Type: FindControlAdditionalSearchParametersType.MultipleValues,
          AdditionalSearchParameters: [
            {
              ColumnName: 'IsActiveUser',
              Value: 'true',
            },
            {
              ColumnName: 'IsActiveUser',
              Value: 'false',
            },
          ],
        },
      }]);
    this.fcAdvancedConfig.set(FindControlIdService.ListServiceSite, [
      this.defaultInactiveCheckbox,
      {
        checkboxText: 'Include External Sites In Search',
        formControl: this.includeExternalSitesCheckbox,
        formControlName: 'includeExternalSitesCheckbox',
        isFormControlDefaultValue: true,
        isCheckboxShouldBeChecked: false,
        parameters: {
          Type: FindControlAdditionalSearchParametersType.Standard,
          AdditionalSearchParameters: [
            {
              ColumnName: 'InternalSite',
              Value: 'true',
            },
          ],
        },
      },
    ]);
  }
}
